import Vue from 'vue';
import Router from 'vue-router';
import store from './store.js';
import Painel from './views/Painel.vue';
import novahome from './views/novahome.vue';

Vue.use(Router);

const router = new Router({
	mode: process.env.CORDOVA_PLATFORM ? 'hash' : 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: novahome,
		},
		{
			path: '/painel',
			component: Painel,
			meta: {
				requiresAuth: true,
			},
			children: [
				{
					name: 'feed',
					path: '',
					component: () =>
						import(/* webpackChunkName: "feed" */ './views/HomeFeed.vue'),
				},
				{
					name: 'legislacoesFiltro',
					path: 'legislacoes/:strFiltro',
					component: () =>
						import(
							/* webpackChunkName: "legislacoes" */ './views/Legislacoes.vue'
						),
				},

				{
					name: 'legislacoes',
					path: 'legislacoes',
					component: () =>
						import(
							/* webpackChunkName: "legislacoes" */ './views/Legislacoes.vue'
						),
				},
				{
					name: 'lei',
					path: 'lei/:idLei/:tituloLei/:vadeMecun?',
					component: () =>
						import(/* webpackChunkName: "lei" */ './views/Lei.vue'),
				},
				{
					name: 'projetoLei',
					path: 'projeto_lei/:idLei/:tituloLei/:vadeMecun?',
					component: () =>
						import(/* webpackChunkName: "projetoLei" */ './views/ProjetoLei.vue'),
				},
				{
					name: 'anotacoes',
					path: 'anotacoes',
					component: () =>
						import(/* webpackChunkName: "anotacoes" */ './views/Anotacoes.vue'),
				},

				{
					name: 'favoritos',
					path: 'favoritos',
					component: () =>
						import(/* webpackChunkName: "favoritos" */ './views/Favoritos.vue'),
				},
				{
					name: 'documentos',
					path: 'documentos',
					component: () =>
						import(
							/* webpackChunkName: "documentos" */ './views/Documentos.vue'
						),
				},
				{
					name: 'perfil',
					path: 'perfil',
					component: () =>
						import(/* webpackChunkName: "perfil" */ './views/Perfil.vue'),
				},
				{
					name: 'grupos',
					path: 'grupos',
					component: () =>
						import(/* webpackChunkName: "equipes" */ './views/Equipes.vue'),
				},
				{
					name: 'gruposDetalhe',
					path: 'grupo/:id_grupo',
					component: () =>
						import(
							/* webpackChunkName: "equipeDetalhe" */ './views/equipeDetalhe.vue'
						),
				},
				{
					name: 'grupoArquivos',
					path: 'grupo/:id_grupo/arquivos',
					component: () =>
						import(
							/* webpackChunkName: "grupoArquivos" */ './views/ArquivosGrupo.vue'
						),
				},

				{
					name: 'Suporte',
					path: 'suporte',
					component: () =>
						import(/* webpackChunkName: "suporte" */ './views/Suporte.vue'),
				},
				{
					name: 'crawler',
					path: 'crawler/:idLei?',
					component: () =>
						import(/* webpackChunkName: "crawler" */ './views/Crawler.vue'),
				},
				{
					name: 'Perfil Usuário',
					path: 'u/:idUsuario/:slugUsuario?',
					component: () =>
						import(
							/* webpackChunkName: "perfilUsuario" */ './views/PerfilUsuario.vue'
						),
				},
			],
		},
		{
			path: '/login',
			name: 'login',
			component: () =>
				import(/* webpackChunkName: "login" */ './views/Login.vue'),
		},
		{
			path: '/cadastro/:plano?',
			name: 'cadastro',
			component: () =>
				import(/* webpackChunkName: "cadastro" */ './views/cadastro.vue'),
		},
		{
			path: '/obrigado',
			name: 'obrigado',
			component: () =>
				import(/* webpackChunkName: "obrigado" */ './views/Obrigado.vue'),
		},
		{
			path: '/obrigado/:gratis?',
			name: 'obrigado-gratis',
			component: () =>
				import(/* webpackChunkName: "obrigado-gratis" */ './views/Obrigado.vue'),
		},
		{
			path: '/nova-senha',
			name: 'changePassword',
			component: () =>
				import(
					/* webpackChunkName: "changePass" */ './views/ChangePassword.vue'
				),
		},
		{
			path: '/confirm-registration',
			name: 'confirmRegistration',
			component: () =>
				import(
					/* webpackChunkName: "confirm" */ './views/ConfirmRegistration.vue'
				),
		},
		{
			path: '/politica-de-privacidade',
			name: 'politicaPrivacidade',
			component: () =>
				import(
					/* webpackChunkName: "politica" */ './views/politicaPrivacidade.vue'
				),
		},
	],
});

// Envia um pageview para o GTM sempre que a rota mudar
router.afterEach((to) => {
	// window.console.log(window.dataLayer)
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'pageview',
		page: to.path, // Envia o caminho da rota
	});
});

router.beforeEach((to, from, next) => {
	if (to.matched.some((record) => record.meta.requiresAuth)) {
		if (store.getters.isLoggedIn) {
			next();
			return;
		}
		next('/login');
	} else {
		next();
	}
});

export default router;
